import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Auth.css';

export default function Register() {
  const navigate = useNavigate();

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>🏗️ Construction Tracker</h1>
          <p>Inscription</p>
        </div>

        <div className="auth-error" style={{ margin: '20px 0' }}>
          <h3 style={{ margin: '0 0 10px 0' }}>❌ Inscription fermée</h3>
          <p style={{ margin: '0' }}>
            L'inscription est fermée. Seul l'administrateur peut créer des comptes.
          </p>
        </div>

        <div className="auth-footer">
          <p>Vous avez un compte ? <button className="btn-link" onClick={() => navigate('/login')}>Se connecter</button></p>
        </div>
      </div>
    </div>
  );
}

